
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vidskiptavinir/[infoID]",
      function () {
        return require("private-next-pages/vidskiptavinir/[infoID].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vidskiptavinir/[infoID]"])
      });
    }
  